// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import dataProducts from './reducer'
export default dataProducts

export { setProductData } from './actions'
export { getProductData } from './thunks'
